/* eslint-disable @typescript-eslint/no-unused-vars */
import request from '../request';

import {
  ExpenseParams,
  ExpenseProps,
  ExpensePropsPaginationResults,
  ExpenseReportProps,
  PostExpenseFiles,
} from './types';

interface ExpenseApprove {
  ids: Array<number>;
  type: string;
  status: string;
}
interface IExpenseStatusCount {
  analyzing: number;
  pending: number;
  pre_approved: number;
}

export const getExpenses = async (page: number = 1, filters?: ExpenseParams, pageSize?: number) => {
  if (filters) {
    const params: Record<string, any> = {
      page_size: pageSize,
    };
    if (filters.property_id) {
      params.property_id = filters.property_id;
    }
    if (filters.host_id) {
      params.host_id = filters.host_id;
    }
    if (filters.expense_status) {
      params.expense_status = filters.expense_status;
    }
    if (filters.refund_date_start) {
      params.refund_date_start = filters.refund_date_start;
      params.refund_date_end = filters.refund_date_end;
    }
    if (filters.register_date_start) {
      params.register_date_start = filters.register_date_start;
      params.register_date_end = filters.register_date_end;
    }
    if (filters.approval_date_start) {
      params.approval_date_start = filters.approval_date_start;
      params.approval_date_end = filters.approval_date_end;
    }
    if (filters.category_id) {
      params.category_id = filters.category_id;
    }

    const { data } = await request.get(`/expenses/?page=${page}`, { params });
    return {
      ...data,
      hasMoreExpenses: data?.next !== null,
      nextPage: data?.next?.split('page=')?.[1] || 1,
    } as ExpensePropsPaginationResults;
  }

  const { data } = await request.get(`/expenses/?page=${page}&page_size=${pageSize}`);
  return {
    ...data,
    hasMoreExpenses: data?.next !== null,
    nextPage: data?.next?.split('page=')?.[1] || 1,
  } as ExpensePropsPaginationResults;
};

export const postExpenses = async (params: ExpenseProps) => {
  const { data } = await request.post('/expenses/', params);
  return data;
};

export const patchExpenses = async (id: number, params: ExpenseProps) => {
  const { data } = await request.patch(`/expenses/${id}/`, params);
  return data;
};

export const getExpensesId = async (id: number) => {
  const { data } = await request.get(`/expenses/${id}/`);
  return data;
};

// Endpoint dedicado (Seazoner-only, IsSeazone no backend) para editar apenas o
// motivo de pendência de uma despesa pendente. Não passa pelo update geral.
export const editExpensePendingReason = async (id: number, pending_reason: string) => {
  const { data } = await request.patch(`/expenses/${id}/pending-reason/`, {
    pending_reason,
  });
  return data;
};

// Endpoint dedicado (Seazoner-only, IsSeazone no backend) para re-disparar a
// triagem de IA de uma despesa em Analyzing/Pending. Não passa pelo update geral.
export const retriggerExpenseTriage = async (id: number) => {
  const { data } = await request.post(`/expenses/${id}/retrigger-triage/`);
  return data;
};

export const getExpensesCategory = async () => {
  const { data } = await request.get(`/expenses/categories/`);
  return data;
};

export const getExpensesCategoryId = async (id: number) => {
  const { data } = await request.get(`/expenses/${id}/items/`);
  return data;
};

export const getExpensesPendingId = async (userId: number) => {
  const { data } = await request.get(`/expenses/pending/${userId}`);
  return data;
};

export const getExpensesStatusCount = async (
  filters: ExpenseParams,
): Promise<IExpenseStatusCount> => {
  const params: Record<string, any> = {};
  if (filters.property_id) {
    params.property_id = filters.property_id;
  }

  if (filters.host_id) {
    params.host_id = filters.host_id;
  }

  if (filters.register_date_start) {
    params.register_date_start = filters.register_date_start;
    params.register_date_end = filters.register_date_end;
  }

  if (filters.approval_date_start) {
    params.approval_date_start = filters.approval_date_start;
    params.approval_date_end = filters.approval_date_end;
  }

  if (filters.category_id) {
    params.category_id = filters.category_id;
  }

  const { data } = await request.get(`/expenses/status_count/`, { params });
  return data;
};

export const getExpensesReport = async (params: ExpenseReportProps) => {
  await request.get('/expense_report/', { params, responseType: 'blob' }).then((response) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `despesas_${params.start_date}_${params.end_date}.csv`);
    document.body.appendChild(link);
    link.click();
  });
};

export const postExpenseFile = async (postExpenseFileData: PostExpenseFiles) => {
  const { data } = await request.post('/expenses_files/', postExpenseFileData);
  return data;
};

export const deleteExpenseFile = async (id: number) => {
  await request.delete(`/expenses_files/${id}`);
};

export const postExpensesApprove = async (expenseApprove: ExpenseApprove) => {
  const { data } = await request.post('/expenses/actions/', expenseApprove);
  return data;
};
